import React from "react";

export default function Header() {
  return <h1>React Movie Search</h1>;
}
